import { render, staticRenderFns } from "./customizeQR.vue?vue&type=template&id=d95a14ba&scoped=true"
import script from "./customizeQR.vue?vue&type=script&lang=js"
export * from "./customizeQR.vue?vue&type=script&lang=js"
import style0 from "./customizeQR.vue?vue&type=style&index=0&id=d95a14ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95a14ba",
  null
  
)

export default component.exports